"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var utilities_1 = require("@sportnet/utilities");
var utilities_2 = require("../../../utilities/utilities");
var ContentContext_1 = tslib_1.__importDefault(require("../../../common/ContentContext"));
var styled_components_1 = tslib_1.__importStar(require("../../../theme/styled-components"));
var Text_1 = tslib_1.__importDefault(require("../FormattedText/Text"));
var SimpleToast_1 = tslib_1.__importDefault(require("./SimpleToast"));
var INDENT = '1.5em';
var FONT_SIZE = '0.9em';
var INPUT_PADDING = '0.2em 0.5em';
var Indent = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: ", ";\n  position: relative;\n"], ["\n  width: ", ";\n  position: relative;\n"])), INDENT);
var ParagraphNr = styled_components_1["default"].a(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  text-decoration: none;\n  color: ", ";\n  :hover {\n    text-decoration: underline;\n  }\n"], ["\n  text-decoration: none;\n  color: ", ";\n  :hover {\n    text-decoration: underline;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.app.textColor;
});
var SectionItem = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  ",
    ";\n"])), function (_a) {
    var ghost = _a.ghost;
    return ghost && styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      color: #b9b9b9;\n      transition: 0.2s color;\n      &:hover {\n        color: #000;\n      }\n    "], ["\n      color: #b9b9b9;\n      transition: 0.2s color;\n      &:hover {\n        color: #000;\n      }\n    "])));
});
var SectionMarker = styled_components_1["default"].a(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  margin-left: 0;\n  font-size: ", ";\n  padding: ", ";\n  text-decoration: none;\n  color: ", ";\n  :hover {\n    text-decoration: underline;\n  }\n"], ["\n  margin-left: 0;\n  font-size: ", ";\n  padding: ", ";\n  text-decoration: none;\n  color: ", ";\n  :hover {\n    text-decoration: underline;\n  }\n"])), FONT_SIZE, INPUT_PADDING, function (_a) {
    var theme = _a.theme;
    return theme.app.textColor;
});
var Title = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var SectionText = styled_components_1["default"](Text_1["default"])(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  flex: 1 0 0;\n  font-size: ", ";\n  padding: ", ";\n  > p {\n    margin: 0;\n  }\n"], ["\n  flex: 1 0 0;\n  font-size: ", ";\n  padding: ", ";\n  > p {\n    margin: 0;\n  }\n"])), FONT_SIZE, INPUT_PADDING);
var Intro = styled_components_1["default"](Text_1["default"])(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n"], ["\n  font-size: ", ";\n"])), FONT_SIZE);
var C = function (_a) {
    var _b = _a.data, sections = _b.sections, paragraph_nr = _b.paragraph_nr, text = _b.text, title = _b.title, elementId = _b.elementId;
    var accessToken = React.useContext(ContentContext_1["default"]).accessToken;
    var _c = React.useState(false), toastVisible = _c[0], setToastVisible = _c[1];
    var paragraphId = "act-" + (elementId || '') + "-\u00A7" + (paragraph_nr ? utilities_1.slugify(paragraph_nr) : '');
    var handleParagraphClick = function (e) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var id, url, err_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accessToken) return [3 /*break*/, 4];
                    id = e.currentTarget.getAttribute('id');
                    if (!id) return [3 /*break*/, 4];
                    url = window.location.href;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(url)];
                case 2:
                    _a.sent();
                    setToastVisible(true);
                    setTimeout(function () {
                        setToastVisible(false);
                    }, 4000);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    function renderSections(ss, path, level) {
        if (path === void 0) { path = []; }
        if (level === void 0) { level = 1; }
        return (React.createElement(React.Fragment, null,
            ss.map(function (section, idx) {
                var markerId = paragraphId + "-" + level + "-" + (idx + 1);
                return (React.createElement(React.Fragment, { key: idx.toString() },
                    React.createElement(SectionItem, { "data-type": "actsection", "data-level": level },
                        Array(level)
                            .fill(0)
                            .map(function (i, iidx) { return (React.createElement(Indent, { key: iidx.toString() })); }),
                        React.createElement(SectionMarker, { id: markerId, href: "#" + markerId, onClick: handleParagraphClick }, section.marker),
                        React.createElement(SectionText, { text: section.text })),
                    section.sections &&
                        section.sections.length > 0 &&
                        renderSections(section.sections, tslib_1.__spreadArrays(path, ['sections', idx]), level + 1),
                    (!section.sections || section.sections.length === 0) && (React.createElement(SectionItem, { ghost: true }, Array(level + 1)
                        .fill(0)
                        .map(function (i, iidx) { return (React.createElement(Indent, { key: iidx.toString() })); })))));
            }),
            React.createElement(SectionItem, { ghost: true }, Array(level)
                .fill(0)
                .map(function (i, iidx) { return (React.createElement(Indent, { key: iidx.toString() })); }))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Title, { "data-type": "actsection", "data-level": "0" },
            React.createElement(ParagraphNr, { id: "" + paragraphId, href: "#" + paragraphId, onClick: handleParagraphClick },
                "\u00A7 ",
                paragraph_nr),
            ' ',
            React.createElement("div", null, title)),
        React.createElement(Intro, { text: text }),
        renderSections(sections || []),
        React.createElement(SimpleToast_1["default"], { visible: toastVisible, text: utilities_2.__('Odkaz na paragraf bol skopírovaný do schránky.') })));
};
exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
